import React, { useState } from 'react'
import classes from './MyStudentsTable.module.css'
import { Button, Tr, Td, Input, Flex, Text, useToast, Select } from '@chakra-ui/react'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import StudentsService from '../../API/StudentsService'
import { useStudentsStore } from '../../store/studentsStore'
import AddTagButton from '../UI/AddTagButton'
import PurchaseTag from '../UI/PurchaseTag'
import SelectCommunicationType from '../SelectCommunicationType/SelectCommunicationType'
import { useStudentsTagsModalStore } from '../../store/modalsStore'
import { CheckIcon } from '@chakra-ui/icons'

function MyStudentsTableRecord({student}) {
    const toast = useToast()
    const updateStudent = useStudentsStore(state => state.updateStudent)
    const onboardingStatuses = useStudentsStore(state => state.onboardingStatuses)
    const [tagsModalDisclosure, setStudent, setPurchase, setIsProlongations] = useStudentsTagsModalStore(
        state => [state.disclosure, state.setStudent, state.setPurchase, state.setIsProlongations]
    )
    const [comment, setComment] = useState(student?.comment || '')
    const [commentLoading, setCommentLoading] = useState(false)
    const patchStudent = useAccessAPI(StudentsService.patchStudent)
    const removeTag = useAccessAPI(StudentsService.deletePurchaseTag)
    const updateOnboardingStatus = useAccessAPI(StudentsService.updateOnboardingStatus)

    const onBDayChange = async (e) => {
        const response = await patchStudent(student.site_id, { birthday: e.target.value })
        if (response?.status === 200) {
            updateStudent({...student, birthday: response.data.birthday})
            toast(toastSuccess('Дата рождения обновлена'))
        } else {
            toast(toastError('Не удалось обновить дату рождения'))
        }
    }

    const saveComment = async () => {
        setCommentLoading(true)
        const response = await patchStudent(student.site_id, { comment: comment })
        if (response?.status === 200) {
            updateStudent({...student, comment: response.data.comment})
            toast(toastSuccess('Комментарий обновлен'))
        } else {
            toast(toastError('Не удалось обновить комментарий'))
        }
        setCommentLoading(false)
    }

    const onOnboardingStatusChange = async (e) => {
        const response = await updateOnboardingStatus(student.site_id, Number(e.target.value))
        if (response?.status === 200) {
            updateStudent({...student, onboarding_status: response.data.onboarding_status})
            toast(toastSuccess('Статус знакомства/онбординга обновлен'))
        } else {
            toast(toastError('Не удалось обновить статус знакомства/онбординга'))
        }
    }

    const deleteTag = async (tag, purchase) => {
        const response = await removeTag(tag.id, purchase.id)
        if (response?.status === 200) {
            updateStudent({...student, purchases: student.purchases.map((el) => {
                if (el.id === purchase.id)
                    el.tags = el.tags.filter((t) => t.id !== tag.id)
                return el
            })})
        }
    }

    const getRowStyle = (purchase) => {
        if (!purchase?.hw?.actual_data?.all_count)
            return ''

        const p = purchase.hw.actual_data.done_count / purchase.hw.actual_data.all_count
        if (p > 0.5)
            return classes.greenRow
        else if (p > 0.2)
            return classes.yellowRow
        else if (p > 0.0)
            return classes.orangeRow
        else
            return classes.redRow
    }

    return (
        <Tr>
            <Td className={classes.fixedCol}>
                <Flex
                    direction="column"
                    gap="4px"
                >
                    <a href={student.vk_link}>
                        {`${student.last_name} ${student.first_name}`}
                    </a>
                    <a href={student.link_on_dialog} style={{color: "gray"}}>
                        Диалог
                    </a>
                </Flex>
            </Td>
            <Td>
                <a href={`https://old.umschool.net/predbannik/core/user/${student.site_id}`}>
                    {student.site_id}
                </a>
            </Td>
            <Td>
                <Input
                    type='date'
                    value={student.birthday}
                    onChange={onBDayChange}
                />
            </Td>
            <Td>{student.email}</Td>
            <Td>
                <SelectCommunicationType student={student} />
            </Td>
            <Td whiteSpace='nowrap'>
                {student.purchases.map((p) => (
                    <Text key={`mggroup${student.site_id}${p.id}`} p='4px'>
                        {p.mggroup
                        ?
                        (
                            p.mggroup?.link
                            ?
                            <a href={p.mggroup.link}>{p.mggroup.name}</a>
                            :
                            <>{p.mggroup.name}</>
                        )
                        :
                        <>-</>
                        }
                    </Text>
                ))}
            </Td>
            <Td textAlign='center'>
                {student.purchases.map((purchase) => (
                    <Text key={`classyear${student.site_id}${purchase.id}`} p='4px'>
                        {purchase.classyear_grade}
                    </Text>
                ))}
            </Td>
            <Td whiteSpace='nowrap'>
                {student.purchases.map((purchase) => (
                    <Text
                        key={`stream${student.site_id}${purchase.id}`}
                        p='4px'
                    >
                        {purchase.productstream_title}
                    </Text>
                ))}
            </Td>
            <Td whiteSpace='nowrap'>
                {student.purchases.map((purchase) => (
                    <Text
                        key={`rateplan${student.site_id}${purchase.id}`}
                        p='4px'
                    >
                        {purchase.rateplan_title}
                    </Text>
                ))}
            </Td>
            <Td textAlign='center'>
                {student.purchases.map((purchase) => (
                    <Text
                        key={`classtype${student.site_id}${purchase.id}`}
                        p='4px'
                        className={purchase.individuallearninggoal_is_priority ? classes.prioritySubject : ''}
                    >
                        {purchase.classtype_title}
                    </Text>
                ))}
            </Td>
            <Td textAlign='center'>
                {student.purchases.map((purchase) => (
                    <Text
                        key={`hw${student.site_id}${purchase.id}`}
                        p='4px'
                        className={getRowStyle(purchase)}
                    >
                        {purchase?.hw?.actual_data?.text || '-'}
                    </Text>
                ))}
            </Td>
            <Td textAlign='center'>
                {student.purchases.map((purchase) => (
                    <Text key={`web${student.site_id}${purchase.id}`} p='4px'>
                        {purchase?.lesson?.actual_data?.text || '-'}
                    </Text>
                ))}
            </Td>
            <Td textAlign='center'>
                {student.purchases.map((purchase) => (
                    <Text key={`goal${student.site_id}${purchase.id}`} p='4px'>
                        {purchase.studentclasstypegoal_number_of_points || "-"}
                    </Text>
                ))}
            </Td>
            <Td textAlign='center'>
                {student.purchases.map((purchase) => (
                    <Text key={`fgoal${student.site_id}${purchase.id}`} p='4px'>
                        {purchase.individuallearninggoal_current_result}
                    </Text>
                ))}
            </Td>
            <Td>
                <Select
                    placeholder='-'
                    value={student.onboarding_status?.id}
                    onChange={onOnboardingStatusChange}
                    minW="250px"
                >
                    {onboardingStatuses.map((status) => (
                        <option value={status.id} key={`onboardingStatus${status.id}`}>
                            {status.title}
                        </option>
                    ))}
                </Select>
            </Td>
            <Td>
                {student.purchases.map((purchase) => (
                    <Flex key={`ptagsflex${purchase.id}`}>
                        {purchase.tags.map((tag) => (
                            <PurchaseTag
                                tag={tag}
                                purchase={purchase}
                                deleteTag={deleteTag}
                                key={`ptag${purchase.id}${tag.id}`}
                            />
                        ))}
                        <AddTagButton
                            onClick={() => {
                                setStudent(student)
                                setPurchase(purchase)
                                setIsProlongations(false)
                                tagsModalDisclosure.onOpen()
                            }}
                        />
                    </Flex>
                ))}
            </Td>
            <Td whiteSpace='nowrap'>
                {student.purchases.map((purchase) => (
                    <Text key={`created-${student.site_id}-${purchase.id}`} p='4px'>
                        {new Date(purchase.created_at).toLocaleString()}
                    </Text>
                ))}
            </Td>
            <Td>
                <Flex gap='6px'>
                    <Input
                        size='sm'
                        minW='200px'
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                    />
                    <Button
                        size='sm'
                        disabled={!comment || commentLoading || student.comment === comment}
                        onClick={saveComment}
                    >
                        <CheckIcon />
                    </Button>
                </Flex>
            </Td>
        </Tr>
    )
}

export default MyStudentsTableRecord
